module.exports = __webpack_public_path__ + "54cf98f5/img/comment-question-icon.7dd26e04.svg";